import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Typography,
  makeStyles,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useMutation, queryCache } from 'react-query';
import { req } from '@omega-energia/react';
import ContratoMigracaoAzDialogStyle from './ContratoMigracaoAzDialog.style';
import { useAuth } from '../../../../auth/authProvider';

const useStyles = makeStyles(ContratoMigracaoAzDialogStyle);

export const ReativarContratoMigracaoAzDialog = props => {
  const { show, onClose, data } = props;

  const [alert, setAlert] = useState({ show: false, msg: '' });

  const { token } = useAuth();

  const classes = useStyles();

  const [reactivateContract] = useMutation(
    id =>
      req.put(
        `migracao-az/contratos/bs/${id}/reactivate`,
        { data },
        {
          token,
        },
      ),
    {
      onSuccess: () => {
        setAlert({ show: true, msg: 'Contrato reativado com sucesso' });
        onClose(false);
      },
      onError: error => {
        setAlert({ show: true, msg: error.message });
        onClose(false);
      },
    },
  );

  function handleCloseAlert() {
    setAlert({ show: false, message: '' });
    queryCache.refetchQueries('fetch-contratos-bs');
  }

  return (
    <>
      <Dialog open={show} classes={{ paper: classes.paper }}>
        <DialogTitle>
          <Box>
            <Typography variant="body1">Atenção!</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" className={classes.content}>
            Deseja continuar com a reativação do contrato ?
          </Typography>
        </DialogContent>
        <DialogActions>
          {' '}
          <Button
            onClick={() => {
              onClose(false);
            }}
            color="primary"
          >
            Não
          </Button>
          <Button color="primary" onClick={() => reactivateContract(data?.id)} autoFocus>
            Sim, continuar
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert.show}
        autoHideDuration={10000}
        message={alert.msg}
        onClose={() => {
          handleCloseAlert();
        }}
      />
    </>
  );
};
